module.exports = __webpack_public_path__ + "static/media/helloworld.835cec61.jpg";